/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';
var searchPartMixin = require('../modules/mixins/searchpart.mixin');

Odigeo.defineWidget('direct_flight_search_manager', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            directFlightsOnly: false,
        },

        setDirectFlightsOnly: function(val) {
            this.save({'directFlightsOnly': val});
        },

        parse: function(searchParams) {
            return Odigeo._.pick(searchParams, 'directFlightsOnly');
        },
    })),

    viewClass: Odigeo.View.extend({
        events: {
            'tap .ip_direct_flight_switcher': 'onChange',
        },

        selectors: {
            input: '.ip_direct_flight_switcher',
            label: '.ip_direct_flight_switcher_label',
        },

        init: function() {
            var inputId = Odigeo._.uniqueId('ip-direct-flight-switcher-');

            this.$cachedSelectors.input.attr('id', inputId);
            this.$cachedSelectors.label.attr('for', inputId);
            this.listenTo(this.model, 'sync:fetch', this.render);
        },

        render: function() {
            this.$cachedSelectors.input.prop('checked', this.model.get('directFlightsOnly'));
        },

        onChange: function() {
            this.model.setDirectFlightsOnly(this.$cachedSelectors.input.is(':checked'));
        },
    }),
}));
